module.exports = __webpack_public_path__ + "img/ring_y_skip_0_0@3x.ea2c0b77.png";